import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  app_name: "مراقب الكابسات - Garbage Trucks Watch",
  maintheme: {
    primary: '#74bdcb',
    secondary: '#e72a56',
    yellow: '#c8b803',
    red: '#bd0404',
    gray: '#e6e6e6',
    background: '#FAFAFA',
    paperColor: '#ffffff',
    primaryColor: '#707070',
    secondaryColor: '#e72a56',
    colorblack: '#000000',
    lightblack: '#333333',
    colorWhite: '#ffffff',
    extrBold: '#3D3D3D',
    extraLight: '#B3B8BD',
    normalblack: '#52575D',
    semilight: '#B3B8BD',
    iconColor: '#74bdcb',
    grid_clear_icon: '#C8D0D6',
    grid_clear_icon_text: 'black',
    grid_search_icon: '#ee9d3'
  },
  logintheme: {
    platte_background_color: '#74bdcb',
    paperColor: '#ffffff',
    primaryColor: '#707070',
    secondaryColor: '#e72a56',
    colorblack: '#000000',
    lightblack: '#333333',
    colorWhite: '#ffffff',
    iconsColor: '#74bdcb'
  },
  sidemenutheme: {
    paperColor: '#ffffff',
    primaryColor: '#707070',
    secondaryColor: '#74bdcb',
    backgroundColor: '#FAFAFA',
    colorblack: '#000000',
    colorWhite: '#ffffff',
    lightblack: '#333333',
    iconColor: '#C8D0D6 ',
    itmeshover: '#74bdcb29 ',
    textitemcolor: '#808080',
    dropdwoncolor: 'rgb(200,208,214)'

  },
  dashboardtheme: {
    background: '#74bdcb',
    paperColor: '#ffffff',
    primaryColor: '#707070',
    secondaryColor: '#51D9F0',
    colorblack: '#000000',
    lightblack: '#333333',
    colorWhite: '#ffffff',
    extrBold: '#3D3D3D',
    extraLight: '#B3B8BD',
    normalblack: '#52575D',
    semilight: '#B3B8BD',
    axisLableColor: '#43425D',
    chartOneSeriesOne: '#A4A1FB',
    chartOneSeriesTwo: '#56D9FE',
    chartOneSeriesThree: '#5FE3A1',

  },
  gridtheme: {
    gridHeader: '#74bdcb',
    paperColor: '#ffffff',
    primaryColor: '#707070',
    secondaryColor: '#51D9F0',
    colorblack: '#000000',
    lightblack: '#333333',
    colorWhite: '#ffffff',
    extrBold: '#3D3D3D',
    extraLight: '#B3B8BD',
    normalblack: '#52575D',
    semilight: '#B3B8BD',
    tooltip_create: '#74bdcb',
    tooltip_create_text: '#fff',
    tooltip_export: 'green',
    tooltip_export_text: '#fff',
    tooltip_import: '#02ab2f',
    tooltip_import_text: '#fff',
    tooltip_map: '#fcc705',
    tooltip_map_text: '#fff',
    tooltip_telegram: '#32affc',
    tooltip_telegram_text: '#fff'

  },
  appbar: {
    background: '#74bdcb',
    paperColor: '#ffffff',
    primaryColor: '#707070',
    secondaryColor: '#e72a56',
    colorblack: '#000000',
    lightblack: '#333333',
    colorWhite: '#ffffff',
    extrBold: '#3D3D3D',
    extraLight: '#B3B8BD',
    normalblack: '#52575D',
    semilight: '#B3B8BD'
  },
  images: {
    companyOne: process.env.REACT_APP_API_URL_image + "public_images/company_one.png",
    companyTwo: process.env.REACT_APP_API_URL_image + "public_images/company_two.png",
    sidebar: process.env.REACT_APP_API_URL_image + "public_images/sidebar.png",
    mainIcon: process.env.REACT_APP_API_URL_image + "public_images/main_icon.png",
    loading: process.env.REACT_APP_API_URL_image + "public_images/loading.png",
    favicon: process.env.REACT_APP_API_URL_image + "public_images/icon.png"
  }
}
export const themesSlice = createSlice({
  name: 'themeData',
  initialState: initialState,
  reducers: {
    setlogintheme: (state, action) => {
      state.logintheme = action.payload
    },
    setSidemenutheme: (state, action) => {
      state.sidemenutheme = action.payload
    },
    setMaintheme: (state, action) => {
      state.maintheme = action.payload
    },
    setDashboardtheme: (state, action) => {
      state.dashboardtheme = action.payload
    },
    setAppBarTheme: (state, action) => {
      state.appbar = action.payload
    },
    setGridTheme: (state, action) => {
      state.gridtheme = action.payload
    },
    setDashboardTheme: (state, action) => {
      state.dashboardtheme = action.payload
    },
    setImages: (state, action) => {
      state.images = action.payload;
    },
    setAllTheme: (state, action) => {
      // Instead of state = action.payload, we need to update each property
      const newState = {
        ...state,
        maintheme: action.payload.maintheme,
        app_name: action.payload.app_name,  
        logintheme: action.payload.logintheme,
        sidemenutheme: action.payload.sidemenutheme,
        dashboardtheme: action.payload.dashboardtheme,
        gridtheme: action.payload.gridtheme,
        appbar: action.payload.appbar,
        images: action.payload.images
      };
      console.log("newState", newState);
      
      return newState;

    }


  }
});

export const {
  setlogintheme,
  setSidemenutheme,
  setAppBarTheme,
  setMaintheme,
  setDashboardtheme,
  setGridTheme,
  setImages,
  setAllTheme
} = themesSlice.actions;



export default themesSlice.reducer;
